export const mergeList = [
  {
    primaryRealm: 3,
    realmsMerged: [3, 14, 17, 22, 23, 24, 46, 47, 55, 57, 60, 65, 76, 79, 82, 88, 89, 138],
    top3: [],
    lastMerge: '14/08/2023'
  },
  {
    primaryRealm: 68,
    realmsMerged: [72, 73, 75, 78, 80, 81, 83, 110, 153, 171, 175, 188, 204, 219],
    top3: [],
    lastMerge: '14/09/2022'
  },
  {
    primaryRealm: 69,
    realmsMerged: [6, 15, 18, 13, 20, 21, 26, 51, 52, 58, 64, 66, 67, 69, 74, 77, 86, 92],
    top3: [],
    lastMerge: '12/05/2023'
  },

  // { primaryRealm: 79, realmsMerged: [ ], top3: [], lastMerge: '07/08/2020' },
  {
    primaryRealm: 87,
    realmsMerged: [2, 4, 12, 19, 29, 31, 32, 33, 34, 35, 37, 39, 40, 42, 43, 44, 45, 49, 50, 61, 70, 71, 85, 87],
    top3: [],
    lastMerge: '11/12/2020'
  },
  {
    primaryRealm: 106,
    realmsMerged: [5, 16, 38, 103, 106, 107, 111, 133, 160, 169, 238],
    top3: [],
    lastMerge: '12/11/2021'
  },
  { primaryRealm: 108, realmsMerged: [1, 7, 8, 28, 41, 48, 54, 62, 93], top3: [], lastMerge: '05/02/2021' },
  {
    primaryRealm: 128,
    realmsMerged: [
      96, 97, 112, 117, 120, 126, 128, 129, 136, 161, 164, 166, 170, 180, 189, 191, 192, 201, 203, 205, 212
    ],
    top3: [],
    lastMerge: '14/09/2022'
  },
  {
    primaryRealm: 135,
    realmsMerged: [90, 113, 121, 135, 139, 141, 155, 157, 163, 172, 176],
    top3: [],
    lastMerge: '12/05/2023'
  },
  {
    primaryRealm: 151,
    realmsMerged: [
      91, 99, 100, 102, 104, 105, 150, 151, 162, 30, 57, 84, 94, 101, 123, 125, 144, 145, 167, 168, 182, 193, 196, 210
    ],
    top3: [],
    lastMerge: '02/02/2024',
    merges: ['23/07/2021']
  },
  {
    primaryRealm: 159,
    realmsMerged: [109, 119, 124, 131, 143, 148, 152, 158, 159, 173, 178, 184, 190, 199, 213, 229, 244, 246],
    top3: [],
    lastMerge: '16/09/2020'
  },

  // {
  //   primaryRealm: 193,
  //   realmsMerged: [30, 57, 84, 94, 101, 123, 125, 144, 145, 167, 168, 182, 193, 196, 210],
  //   top3: [],
  //   lastMerge: '11/12/2020'
  // },
  {
    primaryRealm: 209,
    realmsMerged: [115, 179, 181, 202, 209, 231, 250, 254, 270, 295, 297, 183, 198, 200, 214, 215, 234, 242, 266, 268],
    top3: [],
    lastMerge: '02/02/2024',
    merges: ['25/12/2020']
  },

  // { primaryRealm: 214, realmsMerged: [183, 198, 200, 214, 215, 234, 242, 266, 268], top3: [], lastMerge: '17/09/2020' },
  {
    primaryRealm: 245,
    realmsMerged: [
      207, 208, 217, 218, 221, 225, 245, 249, 267, 283, 284, 286, 304, 310, 335, 362, 389, 401, 407, 418, 423, 427, 435,
      436, 439, 443, 446, 450, 451, 454, 456, 458, 460, 465, 466, 469, 477, 483, 486, 488, 496, 575, 588
    ],
    top3: [],
    lastMerge: '24/12/2021'
  },
  {
    primaryRealm: 255,
    realmsMerged: [
      116, 134, 146, 156, 174, 177, 186, 186, 194, 197, 206, 211, 216, 224, 248, 255, 257, 262, 264, 271, 287, 291, 309,
      324, 378
    ],
    top3: [],
    lastMerge: '15/08/2022'
  },
  {
    primaryRealm: 261,
    realmsMerged: [
      114, 122, 132, 140, 147, 149, 154, 195, 222, 185, 227, 261, 294, 306, 316, 321, 326, 332, 336, 341, 344, 348, 354,
      359, 364, 370, 373, 377, 381, 384, 387, 391, 393, 397, 422
    ],
    top3: [],
    lastMerge: '12/05/2023'
  },
  {
    primaryRealm: 263,
    realmsMerged: [
      220, 223, 226, 228, 230, 232, 233, 235, 237, 239, 240, 243, 247, 252, 253, 256, 259, 260, 263, 265, 269, 272, 273,
      275, 277, 279, 280, 289, 290, 292, 293, 296, 299, 301, 303, 307, 308, 313, 315, 318, 319, 322, 325, 328, 330, 339,
      343, 349, 353, 357, 367, 374, 380, 395, 412, 425, 431, 442, 474, 479, 492
    ],
    top3: [],
    lastMerge: '10/12/2021'
  },
  {
    primaryRealm: 282,
    realmsMerged: [
      236, 241, 251, 276, 282, 288, 299, 300, 302, 311, 314, 317, 320, 323, 329, 337, 338, 342, 353, 360, 375, 379, 383,
      394, 398, 408, 417
    ],
    top3: [],
    lastMerge: '15/08/2022'
  },
  {
    primaryRealm: 285,
    realmsMerged: [285, 305, 327, 333, 334, 346, 347, 351, 363, 366, 368, 390, 402, 426, 429, 432],
    top3: [],
    lastMerge: '09/07/2021'
  },
  {
    primaryRealm: 385,
    realmsMerged: [274, 278, 340, 350, 365, 376, 382, 385, 392, 400, 405, 409, 415, 420, 421, 434],
    top3: [],
    lastMerge: '17/07/2023'
  },

  // { primaryRealm: 434, realmsMerged: [], top3: [], lastMerge: '02/09/2020' },
  {
    primaryRealm: 438,
    realmsMerged: [
      291, 312, 331, 386, 404, 413, 424, 438, 487, 440, 455, 459, 475, 484, 493, 499, 510, 512, 522, 526, 535, 599
    ],
    top3: [],
    lastMerge: '02/02/2024',
    merges: ['18/09/2020']
  },

  // {
  //   primaryRealm: 440,
  //   realmsMerged: [440, 455, 459, 475, 484, 493, 499, 510, 512, 522, 526, 535, 599],
  //   top3: [],
  //   lastMerge: '02/04/2021'
  // },
  {
    primaryRealm: 489,
    realmsMerged: [
      345, 355, 356, 358, 361, 369, 371, 372, 388, 396, 399, 406, 410, 411, 419, 447, 453, 462, 478, 489, 542, 569, 578
    ],
    top3: [],
    lastMerge: '15/04/2022'
  },
  {
    primaryRealm: 507,
    realmsMerged: [
      403, 414, 416, 428, 430, 433, 437, 441, 445, 448, 457, 461, 463, 467, 470, 485, 494, 497, 500, 507, 515, 547, 551,
      565, 537, 549, 560, 562, 571, 580, 584, 586, 594, 600, 606, 610, 613, 621, 628
    ],
    top3: [],
    lastMerge: '24/04/2023'
  },
  {
    primaryRealm: 519,
    realmsMerged: [444, 468, 471, 473, 480, 490, 507, 519, 520, 530, 541],
    top3: [],
    lastMerge: '17/09/2021'
  },

  // { primaryRealm: 528, realmsMerged: [504, 505, 528, 529, 544, 554, 577, 579, 582, 589, 596], top3: [], lastMerge: '18/09/2020' },
  {
    primaryRealm: 568,
    realmsMerged: [504, 505, 523, 524, 528, 529, 536, 544, 554, 557, 558, 563, 566, 568, 577, 579, 582, 583, 589, 596],
    top3: [],
    lastMerge: '13/10/2023'
  },
  { primaryRealm: 573, realmsMerged: [545, 548, 550, 555, 564, 570, 572, 573, 591], top3: [], lastMerge: '02/04/2021' },
  { primaryRealm: 587, realmsMerged: [540, 543, 553, 585, 587, 590, 598, 607, 608], top3: [], lastMerge: '14/10/2020' },
  {
    primaryRealm: 592,
    realmsMerged: [
      449, 452, 464, 472, 476, 482, 491, 495, 498, 502, 508, 511, 514, 517, 518, 561, 592, 603, 605, 612, 632, 633, 639,
      655, 683
    ],
    top3: [],
    lastMerge: '14/09/2022'
  },
  {
    primaryRealm: 615,
    realmsMerged: [531, 532, 534, 556, 574, 576, 593, 601, 615, 620, 622, 636, 648],
    top3: [],
    lastMerge: '12/11/2021'
  },
  {
    primaryRealm: 619,
    realmsMerged: [597, 614, 616, 617, 619, 625, 627, 629, 643, 645, 649],
    top3: [],
    lastMerge: '10/12/2021'
  },
  {
    primaryRealm: 641,
    realmsMerged: [
      481, 501, 503, 509, 513, 516, 521, 525, 527, 533, 538, 539, 546, 552, 559, 567, 581, 595, 602, 609, 618, 626, 634,
      641, 650, 658, 745
    ],
    top3: [],
    lastMerge: '12/05/2023'
  },
  {
    primaryRealm: 646,
    realmsMerged: [604, 623, 624, 637, 640, 646, 653, 667, 674, 681, 693],
    top3: [],
    lastMerge: '05/02/2021'
  },
  { primaryRealm: 656, realmsMerged: [630, 642, 654, 656, 668, 691, 697, 704, 733], top3: [], lastMerge: '02/04/2021' },
  { primaryRealm: 684, realmsMerged: [638, 647, 651, 665, 671, 676, 684, 689, 695], top3: [], lastMerge: '12/11/2021' },
  {
    primaryRealm: 685,
    realmsMerged: [
      652, 657, 663, 666, 669, 672, 675, 682, 685, 692, 694, 698, 700, 703, 707, 711, 713, 718, 720, 727, 730, 732, 734,
      736, 738, 741, 749, 768
    ],
    top3: [],
    lastMerge: '26/11/2021'
  },
  { primaryRealm: 701, realmsMerged: [699, 701, 702, 715, 724, 735, 740, 757, 767], top3: [], lastMerge: '05/02/2021' },
  { primaryRealm: 706, realmsMerged: [644, 662, 664, 706, 710, 712, 714, 719, 723], top3: [], lastMerge: '23/07/2021' },
  { primaryRealm: 717, realmsMerged: [717, 721, 729, 731, 747, 748, 755, 764, 780], top3: [], lastMerge: '19/01/2022' },
  { primaryRealm: 744, realmsMerged: [726, 742, 744, 750, 774, 783, 785, 803, 808], top3: [], lastMerge: '16/04/2021' },
  {
    primaryRealm: 769,
    realmsMerged: [611, 631, 635, 659, 661, 670, 673, 677, 679, 680, 686, 688, 696, 708, 751, 753, 760, 762, 771, 769],
    top3: [],
    lastMerge: '14/09/2022'
  },
  { primaryRealm: 776, realmsMerged: [728, 737, 739, 759, 766, 772, 776, 778, 781], top3: [], lastMerge: '18/02/2022' },
  {
    primaryRealm: 800,
    realmsMerged: [
      660, 678, 687, 690, 705, 709, 716, 722, 725, 743, 746, 754, 756, 763, 773, 777, 784, 791, 793, 800, 802, 862, 867,
      869, 871, 874, 876, 878, 882, 897
    ],
    top3: [],
    lastMerge: '18/02/2022'
  },
  { primaryRealm: 804, realmsMerged: [804, 826, 827, 829, 838, 850, 859, 863, 866], top3: [], lastMerge: '18/02/2022' },
  { primaryRealm: 806, realmsMerged: [790, 794, 797, 799, 806, 811, 813, 822, 845], top3: [], lastMerge: '21/02/2022' },
  { primaryRealm: 810, realmsMerged: [795, 801, 810, 817, 820, 843, 847, 852, 856], top3: [], lastMerge: '16/04/2021' },
  { primaryRealm: 833, realmsMerged: [787, 788, 792, 819, 832, 833, 834, 865, 868], top3: [], lastMerge: '27/05/2022' },
  { primaryRealm: 841, realmsMerged: [831, 839, 841, 881, 889, 898, 910, 912, 916], top3: [], lastMerge: '11/06/2021' },
  { primaryRealm: 848, realmsMerged: [815, 848, 854, 873, 877, 887, 892, 894, 896], top3: [], lastMerge: '21/01/2022' },
  { primaryRealm: 885, realmsMerged: [872, 875, 879, 883, 885, 891, 958, 960, 962], top3: [], lastMerge: '21/01/2022' },
  {
    primaryRealm: 888,
    realmsMerged: [
      809, 812, 814, 818, 821, 823, 825, 828, 830, 835, 837, 840, 842, 846, 849, 853, 855, 858, 864, 880, 884, 886, 888,
      890, 901, 907, 918, 934
    ],
    top3: [],
    lastMerge: '26/11/2021'
  },
  { primaryRealm: 902, realmsMerged: [900, 902, 906, 908, 917, 925, 929, 940, 953], top3: [], lastMerge: '09/07/2021' },
  { primaryRealm: 904, realmsMerged: [824, 836, 857, 861, 870, 904, 946, 949, 956], top3: [], lastMerge: '18/02/2022' },
  { primaryRealm: 921, realmsMerged: [914, 919, 921, 927, 931, 935, 936, 938, 944], top3: [], lastMerge: '11/06/2021' },
  {
    primaryRealm: 966,
    realmsMerged: [
      752, 758, 761, 765, 770, 775, 779, 782, 786, 789, 796, 798, 805, 807, 816, 844, 851, 860, 966, 983, 985, 988, 989,
      992, 994, 996, 1008, 1010, 1012, 1015
    ],
    top3: [],
    lastMerge: '19/01/2022'
  },
  { primaryRealm: 977, realmsMerged: [971, 976, 977, 979, 980, 982, 984, 986, 990], top3: [], lastMerge: '23/07/2021' },
  {
    primaryRealm: 1000,
    realmsMerged: [947, 951, 955, 964, 967, 972, 978, 981, 993, 1000, 1007, 1009, 1013, 1029, 1042],
    top3: [],
    lastMerge: '10/07/2022'
  },
  {
    primaryRealm: 1001,
    realmsMerged: [
      1001, 920, 922, 924, 926, 928, 930, 937, 939, 945, 948, 959, 961, 973, 975, 1001, 923, 932, 935, 941, 942, 987,
      995, 1002, 1011
    ],
    top3: [],
    lastMerge: '26/11/2021'
  },

  // { primaryRealm: 1002, realmsMerged: [923, 932, 935, 941, 942, 987, 995, 1002, 1011, 1016, 1031], top3: [], lastMerge: '27/06/2022' }, '10/11/2023' },
  {
    primaryRealm: 1014,
    realmsMerged: [1014, 1018, 1025, 1026, 1033, 1034, 1036, 1038, 1040],
    top3: [],
    lastMerge: '10/06/2022'
  },
  {
    primaryRealm: 1022,
    realmsMerged: [968, 969, 974, 991, 997, 998, 1004, 1020, 1022, 1109, 1123, 1130],
    top3: [],
    lastMerge: '10/11/2023'
  },
  {
    primaryRealm: 1032,
    realmsMerged: [
      943, 950, 952, 954, 957, 963, 970, 999, 1003, 1005, 1006, 1017, 1019, 1021, 1023, 1024, 1027, 1028, 1030, 1032,
      1035, 1037, 1039, 1041, 1043, 1045, 1049, 1051, 1054, 1056, 1060
    ],
    top3: [],
    lastMerge: '19/01/2022'
  },
  { primaryRealm: 1050, realmsMerged: [1050, 1052, 1057, 1059, 1061, 1118], top3: [], lastMerge: '14/08/2023' },

  // { primaryRealm: 1052, realmsMerged: [1052, 1061, 1118], top3: [], lastMerge: '11/06/2021' }, //'14/08/2023'
  {
    primaryRealm: 1058,
    realmsMerged: [
      1047, 1058, 1062, 1065, 1066, 1067, 1068, 1069, 1074, 1076, 1078, 1080, 1081, 1083, 1085, 1089, 1087, 1091, 1093,
      1095, 1097, 1100, 1102, 1104, 1106, 1108, 1111, 1113, 1115, 1164, 1166, 1169, 1171
    ],
    top3: [],
    lastMerge: '14/09/2022'
  },

  // { primaryRealm: 1072, realmsMerged: [1070, 1072, 1075], top3: [], lastMerge: '19/03/2021' },
  { primaryRealm: 1073, realmsMerged: [1064, 1070, 1071, 1072, 1073, 1075], top3: [], lastMerge: '17/07/2023' },

  // { primaryRealm: 1079, realmsMerged: [1079, 1086, 1090], top3: [], lastMerge: '16/04/2021' },
  {
    primaryRealm: 1088,
    realmsMerged: [1044, 1046, 1048, 1053, 1055, 1063, 1077, 1084, 1088],
    top3: [],
    lastMerge: '13/02/2023'
  },
  { primaryRealm: 1092, realmsMerged: [1079, 1086, 1090, 1092, 1105, 1114], top3: [], lastMerge: '17/07/2023' },

  // { primaryRealm: 1094, realmsMerged: [1094, 1098, 1099], top3: [], lastMerge: '16/04/2021' }, //'14/08/2023'
  { primaryRealm: 1096, realmsMerged: [1082, 1094, 1096, 1098, 1099, 1103], top3: [], lastMerge: '14/08/2023' },
  { primaryRealm: 1101, realmsMerged: [1101, 1107, 1110], top3: [], lastMerge: '04/03/2022' },

  // { primaryRealm: 1121, realmsMerged: [1119, 1121, 1127], top3: [], lastMerge: '03/09/2021' },'10/11/2023' }
  { primaryRealm: 1128, realmsMerged: [1112, 1119, 1121, 1125, 1127, 1128], top3: [], lastMerge: '10/11/2023' },

  // { primaryRealm: 1130, realmsMerged: [1109, 1123, 1130], top3: [], lastMerge: '12/11/2021' },
  // { primaryRealm: 1132, realmsMerged: [1116, 1132, 1134], top3: [], lastMerge: '04/03/2022' },// '14/08/2023' },
  {
    primaryRealm: 1135,
    realmsMerged: [923, 932, 935, 941, 942, 987, 995, 1002, 1011, 1016, 1031, 1135, 1147, 1170],
    top3: [],
    lastMerge: '10/11/2023'
  },
  { primaryRealm: 1141, realmsMerged: [1116, 1132, 1134, 1141, 1142, 1144], top3: [], lastMerge: '14/08/2023' },
  {
    primaryRealm: 1153,
    realmsMerged: [1137, 1139, 1149, 1153, 1156, 1168, 1172, 1184, 1197],
    top3: [],
    lastMerge: '14/10/2022'
  },
  {
    primaryRealm: 1155,
    realmsMerged: [1146, 1155, 1158, 1163, 1181, 1186, 1188, 1190, 1191],
    top3: [],
    lastMerge: '16/01/2023'
  },
  { primaryRealm: 1174, realmsMerged: [1160, 1161, 1167, 1174, 1175, 1182], top3: [], lastMerge: '14/08/2023' },

  // { primaryRealm: 1175, realmsMerged: [1161, 1167, 1175], top3: [], lastMerge: '20/08/2021' },
  {
    primaryRealm: 1199,
    realmsMerged: [
      1117, 1120, 1122, 1124, 1126, 1129, 1131, 1220, 1222, 1229, 1133, 1136, 1199, 1138, 1140, 1143, 1145, 1148, 1150,
      1152, 1154, 1157, 1159, 1162, 1196, 1199, 1201, 1203, 1208, 1210
    ],
    top3: [],
    lastMerge: '18/07/2022'
  },
  {
    primaryRealm: 1202,
    realmsMerged: [1151, 1165, 1177, 1193, 1198, 1202, 1209, 1216, 1239],
    top3: [],
    lastMerge: '14/10/2022'
  },
  {
    primaryRealm: 1205,
    realmsMerged: [1179, 1195, 1200, 1204, 1205, 1207, 1223, 1232, 1246],
    top3: [],
    lastMerge: '13/02/2023'
  },
  {
    primaryRealm: 1226,
    realmsMerged: [1211, 1212, 1214, 1218, 1219, 1221, 1226, 1228, 1233],
    top3: [],
    lastMerge: '14/10/2022'
  },
  {
    primaryRealm: 1227,
    realmsMerged: [
      1173, 1176, 1178, 1180, 1183, 1185, 1187, 1189, 1192, 1194, 1206, 1213, 1227, 1215, 1217, 1224, 1227, 1231, 1234,
      1236, 1238, 1241, 1243, 1245, 1248, 1252, 1255, 1262, 1264
    ],
    top3: [],
    lastMerge: '18/07/2022'
  },
  {
    primaryRealm: 1242,
    realmsMerged: [1225, 1230, 1235, 1237, 1240, 1242, 1249, 1251, 1253],
    top3: [],
    lastMerge: '16/01/2023'
  },
  { primaryRealm: 1247, realmsMerged: [1244, 1247, 1256, 1260, 1263, 1267], top3: [], lastMerge: '17/07/2023' },

  // { primaryRealm: 1256, realmsMerged: [1256, 1263, 1267], top3: [], lastMerge: '10/12/2021' },
  {
    primaryRealm: 1258,
    realmsMerged: [1254, 1258, 1261, 1268, 1270, 1272, 1274, 1277, 1279],
    top3: [],
    lastMerge: '13/02/2023'
  },
  { primaryRealm: 1286, realmsMerged: [1265, 1284, 1286, 1281, 1288, 1291], top3: [], lastMerge: '14/08/2023' },

  // { primaryRealm: 1288, realmsMerged: [1281, 1288, 1291], top3: [], lastMerge: '18/03/2022' },
  // { primaryRealm: 1289, realmsMerged: [1275, 1282, 1289], top3: [], lastMerge: '24/12/2021' },
  {
    primaryRealm: 1307,
    realmsMerged: [1293, 1296, 1298, 1300, 1303, 1305, 1307, 1309, 1312],
    top3: [],
    lastMerge: '16/01/2023'
  },
  { primaryRealm: 1310, realmsMerged: [1275, 1282, 1289, 1310, 1317, 1321], top3: [], lastMerge: '14/08/2023' },
  { primaryRealm: 1313, realmsMerged: [1295, 1302, 1313, 1316, 1323, 1324], top3: [], lastMerge: '14/08/2023' },
  {
    primaryRealm: 1314,
    realmsMerged: [
      1250, 1257, 1259, 1266, 1269, 1271, 1273, 1276, 1278, 1280, 1283, 1285, 1287, 1290, 1292, 1294, 1297, 1299, 1304,
      1306, 1308, 1311, 1314, 1318, 1320
    ],
    top3: [],
    lastMerge: '13/02/2023'
  },

  // { primaryRealm: 1316, realmsMerged: [1316, 1323, 1324], top3: [], lastMerge: '19/01/2022' },
  // { primaryRealm: 1319, realmsMerged: [1319, 1326, 1338], top3: [], lastMerge: '18/03/2022' },
  { primaryRealm: 1330, realmsMerged: [1319, 1326, 1328, 1330, 1338, 1342], top3: [], lastMerge: '14/08/2023' },

  // { primaryRealm: 1336, realmsMerged: [1336, 1340, 1345], top3: [], lastMerge: '21/01/2022' },
  {
    primaryRealm: 1346,
    realmsMerged: [
      1334, 1337, 1343, 1346, 1348, 1350, 1352, 1355, 1357, 1301, 1315, 1322, 1325, 1327, 1329, 1332, 1339, 1341
    ],
    top3: [],
    lastMerge: '27/04/2023'
  },
  { primaryRealm: 1347, realmsMerged: [1331, 1335, 1347, 1349, 1354, 1364], top3: [], lastMerge: '14/08/2023' },

  // { primaryRealm: 1349, realmsMerged: [1349, 1354, 1364], top3: [], lastMerge: '21/01/2022' },
  { primaryRealm: 1351, realmsMerged: [1333, 1336, 1340, 1345, 1351, 1356], top3: [], lastMerge: '17/07/2023' },

  // { primaryRealm: 1353, realmsMerged: [1353, 1369, 1371], top3: [], lastMerge: '29/04/2022' },
  { primaryRealm: 1360, realmsMerged: [1344, 1353, 1360, 1367, 1369, 1371], top3: [], lastMerge: '17/07/2023' },

  // { primaryRealm: 1362, realmsMerged: [1358, 1362, 1366], top3: [], lastMerge: '21/01/2022' },
  // { primaryRealm: 1363, realmsMerged: [1359, 1361, 1363, 1365, 1368, 1370, 1374, 1380, 1382], top3: [], lastMerge: '04/03/2022' },
  { primaryRealm: 1373, realmsMerged: [1358, 1362, 1366, 1373, 1379, 1383], top3: [], lastMerge: '17/07/2023' },

  // { primaryRealm: 1381, realmsMerged: [1381, 1394, 1402], top3: [], lastMerge: '13/10/2023' },
  { primaryRealm: 1385, realmsMerged: [1377, 1381, 1385, 1394, 1398, 1402], top3: [], lastMerge: '13/10/2023' },

  // { primaryRealm: 1388, realmsMerged: [1386, 1388, 1392], top3: [], lastMerge: '18/03/2022' },
  {
    primaryRealm: 1395,
    realmsMerged: [
      1359, 1361, 1363, 1365, 1368, 1370, 1372, 1374, 1376, 1378, 1380, 1382, 1387, 1389, 1395, 1401, 1403, 1409
    ],
    top3: [],
    lastMerge: '17/07/2023'
  },
  { primaryRealm: 1396, realmsMerged: [1375, 1386, 1388, 1390, 1392, 1396], top3: [], lastMerge: '17/07/2023' },
  {
    primaryRealm: 1399,
    realmsMerged: [
      1384, 1391, 1393, 1397, 1399, 1405, 1407, 1411, 1413, 1415, 1417, 1419, 1421, 1424, 1426, 1428, 1430, 1434
    ],
    top3: [],
    lastMerge: '10/11/2023'
  },

  // { primaryRealm: 1400, realmsMerged: [1400, 1408, 1412], top3: [], lastMerge: '29/04/2022' },
  { primaryRealm: 1404, realmsMerged: [1400, 1404, 1408, 1410, 1412, 1414], top3: [], lastMerge: '14/08/2023' },

  // { primaryRealm: 1406, realmsMerged: [1406, 1416, 1420], top3: [], lastMerge: '24/06/2022' },
  // { primaryRealm: 1421, realmsMerged: [1415, 1417, 1419, 1421, 1424, 1426, 1428, 1430, 1434], top3: [], lastMerge: '15/08/2022' },
  { primaryRealm: 1423, realmsMerged: [1406, 1416, 1420, 1422, 1423, 1433], top3: [], lastMerge: '14/08/2023' },
  { primaryRealm: 1425, realmsMerged: [1418, 1425, 1429, 1427, 1431, 1437], top3: [], lastMerge: '13/10/2023' },

  // { primaryRealm: 1431, realmsMerged: [1427, 1431, 1437], top3: [], lastMerge: '24/06/2022' },
  {
    primaryRealm: 1435,
    realmsMerged: [1435, 1439, 1443, 1447, 1450, 1454],
    top3: [],
    lastMerge: '02/02/2024',
    merges: ['08/07/2022']
  },
  {
    primaryRealm: 1448,
    realmsMerged: [1432, 1436, 1438, 1440, 1442, 1444, 1446, 1448, 1459],
    top3: [],
    lastMerge: '14/09/2022'
  },
  {
    primaryRealm: 1449,
    realmsMerged: [1441, 1445, 1449, 1460, 1467, 1473],
    top3: [],
    lastMerge: '02/02/2024',
    merges: ['18/07/2022']
  },

  // { primaryRealm: 1450, realmsMerged: [1447, 1450, 1454], top3: [], lastMerge: '14/10/2022' },
  {
    primaryRealm: 1452,
    realmsMerged: [1452, 1458, 1464, 1456, 1462, 1471],
    top3: [],
    lastMerge: '02/02/2024',
    merges: ['16/01/2023']
  },
  {
    primaryRealm: 1455,
    realmsMerged: [1451, 1453, 1455, 1457, 1461, 1466, 1468, 1472, 1474],
    top3: [],
    lastMerge: '14/10/2022'
  },

  // { primaryRealm: 1460, realmsMerged: [1460, 1467, 1473], top3: [], lastMerge: '16/01/2023' },
  // { primaryRealm: 1462, realmsMerged: [1456, 1462, 1471], top3: [], lastMerge: '14/10/2022' },
  { primaryRealm: 1479, realmsMerged: [1475, 1477, 1479], top3: [], lastMerge: '13/02/2023' },
  { primaryRealm: 1482, realmsMerged: [1469, 1481, 1482], top3: [], lastMerge: '24/04/2023' },
  { primaryRealm: 1484, realmsMerged: [1484, 1488, 1496], top3: [], lastMerge: '24/04/2023' },

  // {
  //   primaryRealm: 1485,
  //   realmsMerged: [1463, 1465, 1470, 1476, 1478, 1480, 1483, 1485, 1487],
  //   top3: [],
  //   lastMerge: '21/11/2022'
  // },
  { primaryRealm: 1486, realmsMerged: [1486, 1492, 1494], top3: [], lastMerge: '13/02/2023' },
  { primaryRealm: 1490, realmsMerged: [1490, 1499, 1501], top3: [], lastMerge: '24/04/2023' },
  {
    primaryRealm: 1495,
    realmsMerged: [
      1463, 1465, 1470, 1476, 1478, 1480, 1483, 1485, 1487, 1489, 1491, 1493, 1495, 1498, 1500, 1502, 1507, 1512
    ],
    top3: [],
    lastMerge: '02/02/2024',
    merges: ['16/01/2023']
  },
  { primaryRealm: 1497, realmsMerged: [1497, 1503, 1505], top3: [], lastMerge: '24/04/2023' },
  { primaryRealm: 1506, realmsMerged: [1506, 1508, 1516], top3: [], lastMerge: '13/02/2023' },
  { primaryRealm: 1511, realmsMerged: [1510, 1511, 1513], top3: [], lastMerge: '24/04/2023' },
  { primaryRealm: 1515, realmsMerged: [1515, 1520], top3: [], lastMerge: '17/07/2023' },

  // { primaryRealm: 1518, realmsMerged: [], top3: [], lastMerge: '' },
  // { primaryRealm: 1520, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1521, realmsMerged: [1518, 1521], top3: [], lastMerge: '17/07/2023' },
  {
    primaryRealm: 1522,
    realmsMerged: [1504, 1509, 1514, 1517, 1522, 1526, 1519, 1524, 1529],
    top3: [],
    lastMerge: '12/05/2023'
  },

  // { primaryRealm: 1523, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1525, realmsMerged: [1523, 1525], top3: [], lastMerge: '17/07/2023' },

  // { primaryRealm: 1527, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1528, realmsMerged: [1528, 1532], top3: [], lastMerge: '14/08/2023' },
  { primaryRealm: 1530, realmsMerged: [1527, 1530], top3: [], lastMerge: '14/08/2023' },

  // { primaryRealm: 1532, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1533, realmsMerged: [1533, 1541], top3: [], lastMerge: '14/08/2023' },

  // { primaryRealm: 1535, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1536, realmsMerged: [1536, 1539], top3: [], lastMerge: '13/10/2023' },
  { primaryRealm: 1537, realmsMerged: [1537, 1544], top3: [], lastMerge: '13/10/2023' },

  // { primaryRealm: 1538, realmsMerged: [1531, 1534, 1538], top3: [], lastMerge: '19/12/2022' },
  // { primaryRealm: 1539, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1540, realmsMerged: [1535, 1540], top3: [], lastMerge: '14/08/2023' },

  // { primaryRealm: 1541, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1542, realmsMerged: [1531, 1534, 1538, 1542, 1547, 1551], top3: [], lastMerge: '10/11/2023' },
  { primaryRealm: 1543, realmsMerged: [1543, 1548], top3: [], lastMerge: '10/11/2023' },

  // { primaryRealm: 1544, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1545, realmsMerged: [1545, 1549], top3: [], lastMerge: '10/11/2023' },
  { primaryRealm: 1546, realmsMerged: [1546, 1552], top3: [], lastMerge: '13/10/2023' },

  // { primaryRealm: 1548, realmsMerged: [], top3: [], lastMerge: '' },
  // { primaryRealm: 1549, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1550, realmsMerged: [1550, 1554], top3: [], lastMerge: '10/11/2023' },

  // { primaryRealm: 1552, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1553, realmsMerged: [], top3: [], lastMerge: '10/11/2023' },

  // { primaryRealm: 1554, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1555, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1557, realmsMerged: [1557, 1561], top3: [], lastMerge: '10/11/2023' },

  // { primaryRealm: 1558, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1559, realmsMerged: [1559, 1563], top3: [], lastMerge: '10/11/2023' },

  // { primaryRealm: 1561, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1562, realmsMerged: [1558, 1562], top3: [], lastMerge: '10/11/2023' },

  // { primaryRealm: 1563, realmsMerged: [], top3: [], lastMerge: '' },
  // { primaryRealm: 1564, realmsMerged: [], top3: [], lastMerge: '' },
  // { primaryRealm: 1565, realmsMerged: [1556, 1560, 1565], top3: [], lastMerge: '24/04/2023' },
  { primaryRealm: 1566, realmsMerged: [1564, 1566], top3: [], lastMerge: '10/11/2023' },
  { primaryRealm: 1567, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1568, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1569, realmsMerged: [1556, 1560, 1565, 1569, 1574, 1578], top3: [], lastMerge: '11/10/2023' },
  { primaryRealm: 1570, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1571, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1572, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1573, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1575, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1576, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1577, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1579, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1580, realmsMerged: [1580, 1584], top3: [], lastMerge: '02/02/2024', merges: [] },

  // { primaryRealm: 1581, realmsMerged: [], top3: [], lastMerge: '' },

  // { primaryRealm: 1582, realmsMerged: [], top3: [], lastMerge: '' },
  // { primaryRealm: 1583, realmsMerged: [], top3: [], lastMerge: '' },
  // { primaryRealm: 1584, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1585, realmsMerged: [1583, 1585], top3: [], lastMerge: '02/02/2024', merges: [] },
  { primaryRealm: 1586, realmsMerged: [1586, 1588], top3: [], lastMerge: '02/02/2024', merges: [] },
  { primaryRealm: 1587, realmsMerged: [1587, 1592], top3: [], lastMerge: '17/07/2023' },

  // { primaryRealm: 1588, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1589, realmsMerged: [1581, 1589], top3: [], lastMerge: '02/02/2024', merges: [] },
  { primaryRealm: 1590, realmsMerged: [1590, 1591], top3: [], lastMerge: '02/02/2024', merges: [] },

  // { primaryRealm: 1591, realmsMerged: [], top3: [], lastMerge: '' },

  // { primaryRealm: 1592, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1593, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1594, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1595, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1596, realmsMerged: [1582, 1596], top3: [], lastMerge: '17/07/2023' },
  { primaryRealm: 1597, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1598, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1599, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1600, realmsMerged: [], top3: [], lastMerge: '' },

  // { primaryRealm: 1601, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1602, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1603, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1604, realmsMerged: [], top3: [], lastMerge: '' },

  // { primaryRealm: 1605, realmsMerged: [1601, 1605], top3: [], lastMerge: '14/08/2023' },
  { primaryRealm: 1606, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1607, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1608, realmsMerged: [], top3: [], lastMerge: '' },
  {
    primaryRealm: 1609,
    realmsMerged: [1601, 1605, 1609, 1613, 1619, 1623],
    top3: [],
    lastMerge: '02/02/2024',
    merges: ['13/10/2023']
  },
  { primaryRealm: 1610, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1611, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1612, realmsMerged: [], top3: [], lastMerge: '' },

  // { primaryRealm: 1613, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1614, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1615, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1616, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1617, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1618, realmsMerged: [], top3: [], lastMerge: '' },

  // { primaryRealm: 1619, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1620, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1621, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1622, realmsMerged: [], top3: [], lastMerge: '' },

  // { primaryRealm: 1623, realmsMerged: [1619, 1623], top3: [], lastMerge: '13/10/2023' },
  { primaryRealm: 1624, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1625, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1626, realmsMerged: [], top3: [], lastMerge: '' },

  // { primaryRealm: 1627, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1628, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1629, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1630, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1631, realmsMerged: [], top3: [], lastMerge: '' },
  {
    primaryRealm: 1632,
    realmsMerged: [1627, 1632, 1650, 1662],
    top3: [],
    lastMerge: '02/02/2024',
    merges: ['10/11/2023']
  },
  { primaryRealm: 1633, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1634, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1635, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1636, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1637, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1638, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1639, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1640, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1641, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1642, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1643, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1644, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1645, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1646, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1647, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1648, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1649, realmsMerged: [], top3: [], lastMerge: '' },

  // { primaryRealm: 1650, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1651, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1652, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1653, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1654, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1655, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1656, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1657, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1658, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1659, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1660, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1661, realmsMerged: [], top3: [], lastMerge: '' },

  // { primaryRealm: 1662, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1663, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1664, realmsMerged: [], top3: [], lastMerge: '' },
  { primaryRealm: 1665, realmsMerged: [], top3: [], lastMerge: '' }
]

export const globeList = [
  { globe: 1, from: 1, to: 87, color: '#02a6e8' },
  { globe: 2, from: 88, to: 174, color: '#fcc006' },
  { globe: 3, from: 175, to: 261, color: '#93d154' },
  { globe: 4, from: 262, to: 348, color: '#e06d03' },
  { globe: 5, from: 349, to: 435, color: '#b2a2c7' },
  { globe: 6, from: 436, to: 522, color: '#fefc13' },
  { globe: 7, from: 523, to: 609, color: '#c05251' },
  { globe: 8, from: 610, to: 696, color: '#94ccdd' },
  { globe: 9, from: 697, to: 783, color: '#f98ef6' },
  { globe: 10, from: 784, to: 870, color: '#c6c19b' },
  { globe: 11, from: 871, to: 957, color: '#c3d79c' },
  { globe: 12, from: 958, to: 1044, color: '#b4a4cb' },
  { globe: 13, from: 1045, to: 1131, color: '#d79596' },
  { globe: 14, from: 1132, to: 1218, color: '#67e1e6' },
  { globe: 15, from: 1219, to: 1305, color: '#fffe98' },
  { globe: 16, from: 1306, to: 1392, color: '#fd4648' },
  { globe: 17, from: 1393, to: 1479, color: '#73b02f' },
  { globe: 18, from: 1480, to: 1566, color: '#7b7b7b' },
  { globe: 19, from: 1567, to: 1625, color: '#538ed2' }
]
